import React from 'react';

import { ReportInspectedProductsByMisstatementView } from './ReportInspectedProductsByMisstatementView';

export const ReportInspectedProductsByMisstatementIIView: React.FC = () => {
  return <ReportInspectedProductsByMisstatementView group="II" />;
};
